import React, { createContext, useState, useContext } from "react";

interface BulkActionActionContextType {
  elementIds: any[];
  setElementIds: (elementIds: any[]) => void;
}

export const BulkActionActionContext =
  createContext<BulkActionActionContextType>({
    elementIds: [],
    setElementIds: () => {},
  });

interface BulkActionActionProviderProps {
  children: React.ReactNode;
}

export const BulkActionActionProvider: React.FC<
  BulkActionActionProviderProps
> = ({ children }) => {
  const [elementIds, setElementIds] = useState<any>([]);

  const value = {
    elementIds,
    setElementIds,
  };
  return (
    <>
    <BulkActionActionContext.Provider value={value}>
      {children}
    </BulkActionActionContext.Provider>
    </>
  );
};
